import { Box, Container, Typography, Avatar, Grid, useTheme, useMediaQuery } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import React from 'react';

const testimonials = [
  {
    quote: '"Too often, views and likes get lumped together as performance metrics – but comments show real reactions from real people. Siftsy quantifies that impact, helping us understand how target consumers are responding to the influencer content we create. It\'s a game changer."',
    author: 'Strategy Director',
    role: 'Influencer Marketing @ McKinney',
    highlight: 'game changer',
    avatarColor: '#EBE5FF'
  },
  // {
  //   quote: '"Siftsy has given us a much needed insight into the qualitative data that engagements should provide, taking data from just a number, and turning into meaning and sentiment."',
  //   author: 'Beckii Flint',
  //   role: 'Co-Founder @ Pepper',
  //   highlight: 'much needed insight',
  //   avatarColor: '#E5F6FF'
  // },
  {
    quote: '"Siftsy has filled a major gap in our tool stack. For years comment analysis has been a manual process but now using Siftsy\'s AI capabilities we can analyze content in a fraction of the time, allowing us to give our clients results as quickly as possible."',
    author: 'Associate Director',
    role: 'Social Analytics & Insights @ Wasserman',
    highlight: 'filled a major gap',
    avatarColor: '#FFE9F3'
  }
];

const TestimonialSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
  // Function to highlight specific text in testimonials
  const highlightText = (text, highlight) => {
    if (!highlight || !text.includes(highlight)) return text;
    
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return parts.map((part, i) => 
      part.toLowerCase() === highlight.toLowerCase() ? 
        <Typography 
          component="span" 
          key={i}
          sx={{ 
            fontWeight: 700,
            color: '#6039CF',
            fontSize: 'inherit',
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: '-2px',
              left: 0,
              width: '100%',
              height: '4px',
              background: 'rgba(159, 122, 234, 0.2)',
              borderRadius: '2px',
              zIndex: -1,
            }
          }}
        >
          {part}
        </Typography> : part
    );
  };

  return (
    <Box 
      sx={{
        py: { xs: 6, sm: 8, md: 12 },
        px: { xs: 2, sm: 3, md: 4 },
        position: 'relative',
        overflow: 'hidden',
        mb: {xs: 6, md: 8},
        borderRadius: 6,
        maxWidth: 1200,
        background: 'linear-gradient(180deg, rgba(235, 229, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: { xs: '28px', sm: '32px', md: '40px', lg: '40px' },
            textAlign: 'center',
            mb: { xs: 4, sm: 5, md: 10 },
            fontFamily: 'Gilroy, sans-serif',
            letterSpacing: { xs: -1, md: -1.8 },
            color: "#4728c4",
            fontWeight: 600,
            position: 'relative',
            '&::after': {
              content: '""',
              display: 'block',
              width: { xs: '60px', md: '80px' },
              height: { xs: '3px', md: '4px' },
              background: 'linear-gradient(90deg, #6B46C1 0%, #9F7AEA 100%)',
              margin: '12px auto 0',
              borderRadius: '2px',
            }
          }}
        >
          {isMobile ? (
            <>
              Here's what they're saying...
              <Typography
                component="span"
                variant="inherit"
                sx={{
                  display: 'block',
                  fontSize: { xs: '28px', sm: '32px' },
                }}
              >
                {/* and agencies{' '} */}
                {/* <Typography
                  component="span"
                  variant="inherit"
                  sx={{
                    color: '#6039CF',
                    fontFamily: "Times New Roman MT Condensed",
                    letterSpacing: -1.5,
                    fontStyle: "italic",
                    fontWeight: 600,
                  }}
                > */}
            
                {/* </Typography> */}
              </Typography>
            </>
          ) : (
            <>
              Here's what they're saying...
              {/* <Typography
                component="span"
                variant="inherit"
                sx={{
                  color: '#6039CF',
                  fontFamily: "Times New Roman MT Condensed",
                  letterSpacing: -1.8,
                  fontStyle: "italic",
                  fontWeight: 600,
                }}
              > */}
            
              {/* </Typography> */}
            </>
          )}
        </Typography>

        <Grid container spacing={{ xs: 10, md: 4 }}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Box
                sx={{
                  bgcolor: 'white',
                  p: { xs: 3, sm: 3.5, md: 4.5 },
                  borderRadius: { xs: 2, md: 3 },
                  height: '100%',
                  boxShadow: '0 8px 30px rgba(107, 70, 193, 0.08)',
                  position: 'relative',
                  transition: 'all 0.3s ease',
                  overflow: 'hidden',
                  '&:hover': {
                    transform: { xs: 'none', md: 'translateY(-8px)' },
                    boxShadow: { 
                      xs: '0 8px 30px rgba(107, 70, 193, 0.08)', 
                      md: '0 20px 50px rgba(107, 70, 193, 0.12)' 
                    },
                  },
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: { xs: '4px', md: '6px' },
                    background: 'linear-gradient(90deg, #6B46C1 0%, #9F7AEA 100%)',
                    borderRadius: '3px 3px 0 0',
                  },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                <Box>
                  <Box 
                    sx={{ 
                      position: 'relative',
                      mb: { xs: 2, md: 3 }
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: '15px', sm: '15px', md: '20px' },
                        color: '#2D2D2D',
                        lineHeight: 1.5,
                        fontWeight: 400,
                        position: 'relative',
                        zIndex: 1,
                       
                      }}
                    >
                      {highlightText(testimonial.quote, testimonial.highlight)}
                    </Typography>
                  </Box>
                </Box>
                
                <Box 
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    pt: { xs: 2, md: 3 },
                    borderTop: '1px solid rgba(107, 70, 193, 0.1)'
                  }}
                >
                  <FormatQuoteIcon
                    sx={{
                      fontSize: { xs: 40, md: 50 },
                      color: '#9F7AEA',
                      opacity: 0.25,
                      transform: 'rotate(180deg)',
                      mr: { xs: 1, md: 1.5 },
                      flexShrink: 0
                    }}
                  />
                  
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: '15px', md: '16px' },
                        fontWeight: 600,
                        color: '#000',
                        lineHeight: 1.2
                      }}
                    >
                      {testimonial.author}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: '13px', md: '14px' },
                        color: '#666',
                        mt: 0.5
                      }}
                    >
                      {testimonial.role}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TestimonialSection; 